export default __webpack_public_path__ + "static/media/connectivity.6320d59d.svg";